'use strict';
angular.module('atex.dam').factory("PublishService", ['$q', 'DamService', 'ContentService', 'DamNotificationService', '$translate',
  function($q, DamService, ContentService, DamNotificationService, $translate) {
    var _publish = function (entry) {
      var deferred = $q.defer();
      DamService.publishContent(entry.id).then(function (result) {
        deferred.resolve({id: result.data});
      }).then(null, function (error) {
        error.messageHandled = true;
        var msg = $translate.getTranslationTable().__ERROR_DURING_EXPORT__;
        if (error.data && error.data.message) {
          msg = error.data.message;
        }
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: msg}), true);
        deferred.reject(error);
      });
      return deferred.promise;
    };

    var _unpublish = function (entry) {
      var deferred = $q.defer();
      DamService.unpublishContent(entry.id).then(function (result) {
        deferred.resolve({id: result.data});
      }).then(null, function (error) {
        error.messageHandled = true;
        var msg = $translate.getTranslationTable().__ERROR_DURING_EXPORT__;
        if (error.data && error.data.message) {
          msg = error.data.message;
        }
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: msg}), true);
        deferred.reject(error);
      });
      return deferred.promise;
    };

    var handler = function (entries, callback) {
      var deferred = $q.defer();

      var exportPromises = entries.map(function (entry) {
        return callback(entry);
      });

      var info = [];

      $q.allSettled(exportPromises).then(function (responses) {
        var successful = true;
        responses.forEach(function (response) {
          info.push(response);
          if (response.state === "rejected"){
            successful = false;
          }
        });
        if (successful) {
          deferred.resolve(info);
        } else {
          deferred.reject(info);
        }
      });

      return deferred.promise;
    };

    return {
      publish: function (entries) {
        return handler(entries, _publish);
      },

      unpublish: function (entries) {
        return handler(entries, _unpublish);
      }

    };

  }]);